import { useEffect } from "react";
import { observer } from "mobx-react-lite";

import { AgentSurfacePlaceholder } from "@/pages/agent/components/agent-surface-placeholder";
import { useAppStore } from "@/store";

/**
 * Stub surface — there's no real overview view yet.
 *
 * On mount we redirect to Projects so the URL state clears out of the
 * "overview" surface. The placeholder below should not normally be visible;
 * it only flashes if the redirect is delayed (e.g. during initial hydration).
 */
export const AgentOverviewPage = observer(() => {
  const { store } = useAppStore();

  useEffect(() => {
    store.agentOverlay.openProjects();
  }, [store.agentOverlay]);

  return (
    <AgentSurfacePlaceholder
      eyebrow="Mem Agent"
      title="Not implemented"
      description="The agent overview surface isn't built yet — redirecting to Projects."
    />
  );
});
